import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input } from '@angular/core';

import { ContractMailingAddress } from '@mp/contract-management/common/domain';

export interface ContractMailingAddressWithCountryName extends ContractMailingAddress {
  countryName?: string;
}

@Component({
  selector: 'mpctm-condition-supplier-address',
  templateUrl: './condition-supplier-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConditionSupplierAddressComponent {
  readonly supplierAddress: InputSignal<ContractMailingAddressWithCountryName> =
    input.required<ContractMailingAddressWithCountryName>();

  protected readonly formattedAddressInfo: Signal<string> = computed(() => this.formatAddressInfo());

  private formatAddressInfo(): string {
    const supplierAddress: ContractMailingAddress = this.supplierAddress();

    const zipCode: string = supplierAddress.zipCode || '';
    const city: string = supplierAddress.city || '';
    const countryCode: string = supplierAddress.countryCode || '';

    let formattedAddress = `${zipCode} ${city}`.trim();

    if (countryCode) {
      formattedAddress += `, ${countryCode}`;
    }

    return formattedAddress;
  }
}
